import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Box, Container, Typography, IconButton, Link as MuiLink, useTheme } from '@mui/material';
import { Link } from 'react-router';

export const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid',
        borderColor: theme.palette.divider,
        py: 6,
        bgcolor:
          theme.palette.mode === 'dark' ? 'rgba(2, 6, 23, 0.95)' : 'rgba(248, 250, 252, 0.95)',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 3,
          }}
        >
          {/* Logo and Copyright */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Box
              component={Link}
              to="/"
              sx={{
                display: 'inline-block',
                fontFamily: '"Space Grotesk", sans-serif',
                fontWeight: 700,
                fontSize: '1.25rem',
                color: 'text.primary',
                textDecoration: 'none',
                mb: 1,
              }}
            >
              SN
              <Box component="span" sx={{ color: 'primary.main' }}>
                .
              </Box>
            </Box>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              © {new Date().getFullYear()} Shubham Nandeshwar. Built with React & MUI.
            </Typography>
          </Box>

          {/* Social Links */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <IconButton
              component={MuiLink}
              href="https://github.com/nandeshwarshubh"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'text.secondary',
                '&:hover': {
                  color: 'text.primary',
                  transform: 'scale(1.1)',
                },
                transition: 'all 0.3s',
              }}
            >
              <GitHubIcon />
            </IconButton>
            <IconButton
              component={MuiLink}
              href="https://linkedin.com/in/shubhamnandeshwar"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'text.secondary',
                '&:hover': {
                  color: 'text.primary',
                  transform: 'scale(1.1)',
                },
                transition: 'all 0.3s',
              }}
            >
              <LinkedInIcon />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
